import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,



    routes: [
        // exemple pour code splitting @garder
        // {
        //     path: '/signup',
        //     name: 'signup',
        //     // route level code-splitting
        //     // this generates a separate chunk (about.[hash].js) for this route
        //     // which is lazy-loaded when the route is visited.
        //     component: () => import(/* webpackChunkName: "about" */ './views/SignupView.vue')
        // },

        // redirection du domain vide vers signup
        {path: '/',name: 'home',redirect: '/fr/login'},

        {
            // path: '/:locale/impersonate/:targetUser/:userSlug/:organization/:roles/:token/:workspaces/:activeWorkspace/:activeWorkspaceCurrency/:subIsPremium',
            path: '/:locale/impersonate/:targetUser/:userSlug/:organization/:roles/:token/:workspaces/:activeWorkspace/:activeWorkspaceCurrency',

            name: 'impersonate',
            component: () => import('./views/ImpersonateView.vue'),
        },

        {
            path: '/:locale/signup',
            name: 'signup',
            component: () => import(/* webpackChunkName: "about" */ './views/SignupView.vue'),
            meta: { requiresNotAuth: true }
        },
        {
            path: '/:locale/signup/data/:organization',
            name: 'signupData',
            component: () => import(/* webpackChunkName: "about" */ './views/SignupDataView.vue'),
            meta: { requiresAuth: true }
        },

        {
            path: '/:locale/signup-invit/:token',
            name: 'signupInvit',
            component: () => import(/* webpackChunkName: "about" */ './views/SignupInvitView.vue'),
            meta: { requiresNotAuth: true }
        },
        {
            path: '/:locale/verify-account/:token',
            name: 'verify-account',
            component: () => import(/* webpackChunkName: "about" */ './views/VerifyAccountView.vue'),
        },
        {
            path: '/:locale/logout',
            name: 'logout',
            component: () => import(/* webpackChunkName: "logout" */ './views/LogoutView.vue')
        },
        {
            path: '/:locale/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "about" */ './views/LoginView.vue'),
            meta: { requiresNotAuth: true }

        }, {
            path: '/:locale/password/request',
            name: 'password-request',
            component: () => import(/* webpackChunkName: "about" */ './views/PasswordRequestView.vue')
        },
        {
            path: '/:locale/password/reset/:token',
            name: 'password-reset',
            component: () => import(/* webpackChunkName: "about" */ './views/PasswordResetView.vue')
        },
        {
            path: '/:locale/terms',
            name: 'terms',
            component: () => import(/* webpackChunkName: "TermsView" */ './views/TermsView.vue')
        },

        {
            path: '/:locale/:organization/timeclock',
            name: 'timeclock',
            component: () => import(/* webpackChunkName: "about" */ './views/TimeclockView.vue'),
            meta: { requiresAuth: true }

        },
        {
            path: '/:locale/:organization/timeTracking',
            name: 'timeTracking',
            component: () => import(/* webpackChunkName: "about" */ './views/TimeTrackingView.vue'),
            meta: { requiresAuth: true }

        },
        {
            path: '/:locale/:organization/user/settings',
            name: 'user-settings',
            component: () => import(/* webpackChunkName: "about" */ './views/UserSettingsView.vue'),
            meta: { requiresAuth: true }

        },
        {
            path: '/:locale/:organization/projects',
            name: 'projects',
            component: () => import(/* webpackChunkName: "about" */ './views/ProjectsView.vue'),
            props: route => ({
                query: route.query.editProject, // string slug du projet à ouvrir en édition

            }),
            meta: { requiresAuth: true }
        },
        {
            path: '/:locale/:organization/:workspace/tags',
            name: 'tags',
            component: () => import(/* webpackChunkName: "about" */ './views/TagsView.vue'),
            props: route => ({

            }),
            meta: { requiresAuth: true }
        },
        {
            path: '/:locale/:organization/projects/:project/details',
            name: 'project-details',
            component: () => import(/* webpackChunkName: "about" */ './views/ProjectDetailsView.vue'),
            meta: { requiresAuth: true , role: 'ROLE_ADMIN'}
        },
        {
            path: '/:locale/:organization/team/users',
            name: 'teamUsers',
            component: () => import(/* webpackChunkName: "about" */ './views/UsersView.vue'),
            meta: { requiresAuth: true }

        },
        {
            path: '/:locale/:organization/clients',
            name: 'clients',
            component: () => import(/* webpackChunkName: "about" */ './views/ClientsView.vue'),
            meta: { requiresAuth: true , role: 'ROLE_ADMIN'}

        },
        {
            path: '/:locale/:organization/:workspace/subscription',
            name: 'workspace-subscription',
            component: () => import(/* webpackChunkName: "about" */ './views/WorkspaceSubscriptionView.vue'),
            props: route => ({
                query: route.query.cycle, // string (month|year) | cycle de facturation à afficher au chargement
                query: route.query.pgr, // string le groupe de plan à charger

            }),
            meta: { requiresAuth: true ,
                role: 'ROLE_ADMIN'
            }
        },
        {
            path: '/:locale/:organization/:workspace/subscription/cancel',
            name: 'subscription-cancel',
            component: () => import(/* webpackChunkName: "about" */ './views/SubscriptionCancelView.vue'),
            props: route => ({
                query: route.query.user, // string | Email de l'user  (sert pour tracking abandon de panier)
                priceIde: route.query.priceId, //string |  Stripe priceId (sert pour tracking abandon de panier)
            }),
            meta: { requiresAuth: true ,
                role: 'ROLE_ADMIN'
            }
        },
        {
            path: '/:locale/:organization/:workspace/subscription/success',
            name: 'subscription-success',
            component: () => import(/* webpackChunkName: "about" */ './views/SubscriptionSuccessView.vue'),
            props: route => ({
                query: route.query.client_reference_id, // string id du workspace auquel appartien la subscription

            }),
            meta: { requiresAuth: true ,
                role: 'ROLE_ADMIN'
            }
        },
        {
            /** ⚠️⚠️ ATTENTION : EN CAS DE MODIF DE CETTE ROUTE FAIRE MAJ DU LIEN DANS :
            * LE TEMPLATE DE L'EMAIL : foundationForEmails/src/pages/weeklyTaskReport.html
             * Les drip mails onboarding :
                 * au moins 2 @todo les définir
             * **/
            path: '/:locale/:organization/reports/:reportType(summary|detailed)/start=:startDate?/end=:endDate?/',
            name: 'reports',
            component: () => import(/* webpackChunkName: "about" */ './views/ReportsView.vue'),
            props: route => ({
                query: route.query.pjctArchShow, // string (archived|active|all)
                query: route.query.pjctNoRel, // string (1|0)
                query: route.query.pjctProjects, // // String de slugs projet (ex 0=project_slug)
                query: route.query.cltArchShow, // string (archived|active|all)
                query: route.query.cltNoRel, // string (1|0)
                query: route.query.cltClients, // String de slugs client (ex 0=client_slug)
                query: route.query.billable, // string (billable|nonB|all)
                query: route.query.taskNameFilter, // string
                query: route.query.taskNameNoRel, // string (1|0)
                query: route.query.groupCrit, // string (user|client|project)
                query: route.query.mergeCrit, // string (user|timerecord|project)
                query: route.query.tagArchShow, // string (archived|active|all)
                query: route.query.tagNoRel, // string (1|0)
                query: route.query.tagTags, // String de slugs tags (ex 0=tag_slug)

            }),

            meta: { requiresAuth: true ,

            }

        },
        {
            path: '/:locale/:organization/settings',
            name: 'organization-settings',
            component: () => import('./views/OrganizationSettingsView.vue'),
            meta: { role: 'ROLE_ADMIN'}
        },
        {
            // erreur 403
            path: '/:locale/forbidden',
            name: 'forbidden',
            component: () => import('./views/ForbiddenView.vue')
        },

        {
            // page de maintenance
            path: '/:locale/maintenance',
            name: 'maintenance',
            component: () => import('./views/MaintenanceView.vue'),
            props: route => ({
                query: route.query.returnDate, // string La date de retour prévue (au format DD-MM-YYYY hh:mm)
            }),
        },

        // La dernière route catch les 404. LAISSER À LA FIN !
        {
            path: '*',
            name: 'notFound',
            component: () => import('./views/NotFoundView.vue')
        }

    ]

})
